var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.validLinks),function(link){return _c('div',{key:link.key},[_c('router-link',{attrs:{"to":link}},[_vm._v(" View all "+_vm._s(link.name)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }